<template>
    <div v-if="loaded">
        <form class="signup_form" @submit.prevent="handleSubmit">
          <ul>
              <div class="part">
                  <li>
                      <label>שם המשרד</label>
                      <input type="text" required v-model="formData.company_name" >
                  </li>
                  <li>
                      <label>שם איש קשר</label>
                      <input type="text" v-model="formData.contact_name">
                      <span class="helper_text">אפשר לשנות לאחר יצירת הפרופיל למשרד</span>
                  </li>
                  <li>
                      <label>כתובת מייל של המשרד</label>
                      <input type="email" required v-model="formData.email" :disabled="state == 'edit'">
                      <span class="helper_text">כדי שנוכל לשלוח לך אישור הרשמה</span>
                  </li>
                  <li v-if="state != 'edit'" >
                      <label>בחירת סיסמא</label>
                      <div class="eye"  :class="{show: fa-eye-slash}">
                        <div v-if="!showPassword" @click="showPassword=!showPassword">
                            <i class="fas fa-eye"></i>
                        </div>
                        <div v-else @click="showPassword=!showPassword">
                            <i class="fas fa-eye-slash"></i>
                        </div>
                        <input :type="showPassword ? 'text' : 'password'" required v-model="formData.password">
                      </div>
                      <span class="helper_text">לפחות 8 תווים</span>
                  </li>
                  <li v-if="state != 'edit'">
                      <label>סיסמא בשנית</label>
                      <input :type="showPassword ? 'text' : 'password'"  required v-model="repeatPasswortInput">
                      <span class="helper_text">לפחות 8 תווים</span>
                  </li>
                  <li v-if="state != 'edit'" class="rows terms row">
                      <input type="checkbox" required v-model="approveTermsInput" >
                      <label>
                          <span>אני מאשר בזאת את </span>
                          <a href="/terms.pdf" target="_blank">תקנון המכרז השקוף </a>
                      </label>
                  </li>
              </div>
              <input v-if="state != 'edit'" type="submit" class="btn" value="המשך">
          </ul>
        </form>
    </div>
</template>
  
<script>
  
  export default {
      props: ["updatedData", "state"],
      data() {
          return {
              repeatPasswortInput: '',
              approveTermsInput: false,
              showPassword: false,
              loaded:false,
              formData: {
                  company_name: '',
                  contact_name: '',
                  email: '',
                  password: '',
                  step: 1
              }
          }
      },
      mounted() {
        this.init()
      },
      methods: {
        init() {
            if (this.updatedData) {
                for (const key in this.formData) {
                    if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
                }
                this.repeatPasswortInput = this.updatedData['password']
                this.loaded = true
            }
        },
          handleSubmit() {
              let error = this.validate();
              if (error) {
                  this.$swal({
                      toast: true, 
                      position: 'bottom-start', 
                      showConfirmButton: false,
                      timer: 3000, 
                      icon: 'error', 
                      title: error 
                  });
                  return false;
              }
              this.$emit('next', this.formData)
          },
          validate() {
              const rgxPswd = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d\W]{8,}$/;
              if (!rgxPswd.test(this.formData.password)) {
                  return 'הסיסמא חייבת אות ומספר ומינימום 8 תווים'
              }
              if (this.formData.password !== this.repeatPasswortInput) {
                  return 'הסיסמאות לא שוות'
              }
              if (!this.approveTermsInput) {
                  return 'חובה לאשר תקנון'
              }
          }
      },
      watch: {
        updatedData() {
            this.init()

        },
        formData: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
      }
  
  }
  </script>
  
  <style lang="scss">
  .rows.row{flex-direction: row !important;}
  </style>